import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { Link } from '@tanstack/react-router'

const Page404 = () => {
  return (
    <div className=' bg-linear-to-tl from-background via-primary-5 to-background'>
      <div className='w-screen h-screen relative bg-[url(/assets/images/texture.png)] bg-cover bg-no-repeat bg-center flex items-center justify-center flex-col overflow-x-hidden'>
        <p className='text-[200px] md:text-[500px] text-transparent absolute left-[50%] top-[30%] md:top-[50%] -translate-[50%] leading-none text-center [text-stroke:0.5px_#fff] [-webkit-text-stroke:0.5px_#fff]'>404</p>
        <div className='relative z-10 flex items-center text-center gap-5 justify-center flex-col'>
          <p className='text-3xl md:text-5xl'>Sayfa Bulunamadı</p>
          <p className='text-base md:text-xl'>Üzgünüz, aradığınız sayfayı bulamadık.<br /> Belki bağlantı güncel değil ya da sayfa taşınmış olabilir.</p>
          <Link to='/users' className={cn(buttonVariants({ variant: 'default' }))}>
            Anasayfaya Dön
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Page404